<template>
	<div class="ce-text">
		<div class="ce-headline">
			<div
				v-if="getHeadline(objectdata.headline.unit, objectdata.headline.value)"
				v-html="getHeadline(objectdata.headline.unit, objectdata.headline.value)"
			/>
		</div>
		<!-- <div v-html="objectdata.text"/> -->
		<img
			v-if="objectdata.addImage && objectdata.singleSRC && !objectdata.floating && !objectdata.imagemargin"
			class="textblock-image"
			:src="objectdata.singleSRC"
		>
		<img
			v-else-if="objectdata.addImage && objectdata.singleSRC && objectdata.floating && !objectdata.imagemargin"
			class="textblock-image floatLeft"
			:src="objectdata.singleSRC"
		>
		<img
			v-else-if="objectdata.addImage && objectdata.singleSRC && objectdata.floating && objectdata.imagemargin"
			class="textblock-image floatLeft"
			:style="this.getMargins()"
			:src="objectdata.singleSRC"
		>
		<p v-bind:inner-html.prop="objectdata.text | replaceNbsp | replaceAmp"/>
	</div>
</template>
<script>
	import Base from "./Base.vue";
	export default {
		extends: Base,
		props: {
			type: false,
			objectdata: {}
		},

		data() {
			return {};
		},
		created() {},
		methods: {
			getMargins() {
				let margins = "";
				if (this.objectdata.imagemargin.top) {
					margins +=
						"margin-top: " +
						this.objectdata.imagemargin.top +
						this.objectdata.imagemargin.unit +
						";";
				}
				if (this.objectdata.imagemargin.right) {
					margins +=
						"margin-right: " +
						this.objectdata.imagemargin.right +
						this.objectdata.imagemargin.unit +
						";";
				}
				if (this.objectdata.imagemargin.bottom) {
					margins +=
						"margin-bottom: " +
						this.objectdata.imagemargin.bottom +
						this.objectdata.imagemargin.unit +
						";";
				}
				if (this.objectdata.imagemargin.left) {
					margins +=
						"margin-left: " +
						this.objectdata.imagemargin.left +
						this.objectdata.imagemargin.unit +
						";";
				}
				return margins;
			}
		},
		composed: {}
	};
</script>

<style lang="scss">
</style>